import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  EventEmitter,
  inject,
  input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { ThemeAssetComponent } from '@partners/themes';
import { CardBodyDirective, CardContainerComponent, StrokedButtonComponent } from '@partners/ui';

@Component({
  selector: 'document-preview',
  standalone: true,
  imports: [StrokedButtonComponent, ThemeAssetComponent, CardContainerComponent, CardBodyDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'document-preview'
  },

  template: `
    <card-container>
      <ng-template cardBody>
        @if (!base64()) {
        <div class="dashed-border">
          <div layout="column" layout-align="center center" class="pdd-bt-md pdd-tp-md text-center">
            <theme-asset asset="plus-icon" maxWidth="1.5rem"></theme-asset>
            <p class="mrg-tp-xs">{{ noDocumentText() }}</p>
          </div>
        </div>
        } @else {
        <img [src]="src()" alt="תמונה או קובץ שהעלתה" />
        @if (deleteIcon()) {
        <stroked-button
          class="delete-button"
          iconName="trash-can-icon-dark"
          iconSize="sm"
          (click)="handleRemoveClick()"
        ></stroked-button>
        } }
      </ng-template>
    </card-container>
  `
})
export class DocumentPreviewComponent {
  private readonly cdr = inject(ChangeDetectorRef);
  deleteIcon = input<string>('trash-can-icon-dark');
  srcPrefix = input<string>('data:image/jpeg;base64, ');
  base64 = input.required<string>();
  src = computed<string>(() => this.srcPrefix() + this.base64());
  /**
   * @description Text to display when no document is supplied to the component
   */
  noDocumentText = input<string>('');

  @Output()
  removeDocument = new EventEmitter();

  /**
   * @description Handles remove button click event
   * @param event Mouse event to stop propagation
   */
  handleRemoveClick(): void {
    this.removeDocument.emit();
    this.cdr.markForCheck();
  }
}
